import { secureGet } from '../utils/HttpUtils';

export interface CategoryType {
  id: number;
  name: string;
}

const apiUrls = {
  categoryTypes: '/v1/private/clients/category-types',
};

export const getCategoryTypes = async (): Promise<CategoryType[]> => {
  try {
    const result = await secureGet(apiUrls.categoryTypes);
    // Extraer el array del objeto response
    return result.data || result;
  } catch (error) {
    console.error('Error fetching category types:', error);
    throw error;
  }
};
